<template lang="pug">
  .HorizontalScrollList
    swiper.HorizontalScrollList_carousel(
      :options="swiperOption"
      :cleanStylesOnDestroy="false"
      @progress="swiperProgressHandler"
      ref="swiperEl"
    )
      slot

    ScrollIndicator(
      orientation="horizontal"
      :progress="swiperProgress"
    )
</template>

<script>

import { TweenLite } from 'gsap'
import ScrollIndicator from '@/components/ScrollIndicator'

export default {
  components: {
    ScrollIndicator
  },
  props: [ 'withoutWheel' ],
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        centeredSlides: true,
        freeMode: true,
        freeModeMomentum: true,
        mousewheel: !this.withoutWheel
      },
      swiperProgress: 0
    }
  },
  methods: {
    swiperProgressHandler (progress) {
      this.swiperProgress = progress
    }
  }
}
</script>

<style lang="stylus">
.VerticalScrollList

  display flex
  flex-direction column
  flex-wrap: nowrap
  align-items: center
  height 100%
  width 90%
  left 5%
  position absolute
  overflow-y auto

  padding-top 30vh
  cursor ns-resize
  box-sizing border-box

  .ListItem

    margin 10px auto!important
    display block
    padding-bottom 97%
    box-sizing border-box

    &-landscape

      .ListItem_wrapper

        padding-bottom 100%

  .ListItem:last-child

    margin-bottom 50px!important

.HorizontalScrollList
  display flex
  flex-direction row
  cursor ew-resize
  flex-wrap: nowrap
  align-items: center

.swiper-container

  height 100%

.swiper-wrapper

  display flex
  flex-direction row
  align-items center
  transition all 2s $ease

.swiper-slide

  transition all 0.8s $ease
  height auto
  margin auto 0px

.HorizontalScrollList

  .swiper-slide

    &:after

      content ''
      position absolute
      transition all 1.4s $ease
      top 0px
      left 0px
      width 100%
      opacity 0
      height 100%
      pointer-events none
      touch-action none
      background-color $black

    // &-next

      // &:after

      //   opacity 0.7
      //   pointer-events auto
      //   touch-action auto

      // transform scale(0.9)

      // .ListItem:after

      //   border-color transparent!important
</style>
